import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CREATE_USER,
  EDIT_USER,
  LOAD_USERS_LIST,
} from './user';
import {
  ADD_EXCHANGE_AGGREGATOR_USER,
  DELETE_EXCHANGE_AGGREGATOR_USER,
  EDIT_EXCHANGE_HANDLERS_ACCOUNTS,
  LOAD_EXCHANGES_INFO
} from "./exchanges";
import { LOAD_HANDLER_ACCOUNTS_LIST, LOAD_HANDLERS_INFO } from "@/store/const/handlers";


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users',
  [EDIT_USER]: 'api/users/:id:', // !!!name
  [LOAD_EXCHANGES_INFO]: 'api/exchanges',
  [LOAD_HANDLERS_INFO]: 'api/handlers',
  [LOAD_HANDLER_ACCOUNTS_LIST]: 'api/handlers/accounts',
  [ADD_EXCHANGE_AGGREGATOR_USER]: 'api/exchanges/aggregator/:group:',
  [DELETE_EXCHANGE_AGGREGATOR_USER]: 'api/exchanges/aggregator/:group:',
  [EDIT_EXCHANGE_HANDLERS_ACCOUNTS]: 'api/exchanges/:id:/accounts',

};
export default path;
